import { Box, Button, Flex, Text } from "@mantine/core";
import React, { useState } from "react";
import { SiGooglecalendar } from "react-icons/si";
import IntegrationsModal from "./IntegrationsModal";

const GoogleCalendarWarning = () => {
  const [integrationsModalOpened, setIntegrationsModalOpened] = useState(false);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#FFF5F5",
          borderBottom: "1px solid #FFC9C9",
        }}
        py="xs"
      >
        <Flex align="center" justify="center" gap="xs">
          <SiGooglecalendar color="#C92A2A" size={18} />
          <Text
            color="#C92A2A"
            size="sm"
            weight={500}
            style={{
              cursor: "pointer",
            }}
          >
            Google calendar is not connected
          </Text>
          <Button
            size="xs"
            variant="light"
            color="red"
            onClick={() => setIntegrationsModalOpened(true)}
          >
            Connect
          </Button>
        </Flex>
      </Box>

      <IntegrationsModal
        opened={integrationsModalOpened}
        setOpened={setIntegrationsModalOpened}
      />
    </>
  );
};

export default GoogleCalendarWarning;
